import { render, staticRenderFns } from "./BaseSettingEdit.vue?vue&type=template&id=003d20b2&"
import script from "./BaseSettingEdit.vue?vue&type=script&lang=js&"
export * from "./BaseSettingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports